export function showToast(message, type = 'success') {
  let container = document.getElementById('admin-toast-container')

  if (!container) {
    container = document.createElement('div')
    container.id = 'admin-toast-container'
    container.className = 'admin-toast-container'
    document.body.appendChild(container)
  }

  const toast = document.createElement('div')
  toast.className = `admin-toast alert alert-${type}`
  toast.textContent = message
  container.appendChild(toast)

  requestAnimationFrame(() => toast.classList.add('admin-toast--visible'))

  setTimeout(() => {
    toast.classList.remove('admin-toast--visible')
    setTimeout(() => toast.remove(), 300)
  }, 3500)
}
